<ng-container>
  <button class="task-button"
          [ngClass]="{'task-button-disabled': taskSelect!.disabled}"
          [ngStyle]="{'background-image':'url(' + taskSelect!.buttonImage + ')'}"
          [disabled]="taskSelect!.disabled || initializing"
          (click)="onTaskClick()"
          (touchstart)="onTouchStart()"
          (touchend)="onTouchEnd($event)"
          (mouseover)="onMouseOver()"
          (mouseleave)="onMouseLeave()">

    @if (alternating) {
      <p class="font-18 task-btn-task-type" [hidden]="taskSelect!.showPassageTitle">{{taskSelect!.type}}</p>
      <p class="font-18 task-btn-task-name" [hidden]="taskSelect!.showPassageTitle">{{taskSelect!.name}}</p>
      <p [hidden]="!taskSelect!.showPassageTitle" class="task-btn-passage-title font-passage-title">{{ taskSelect!.passageTitle | formatString }}</p>
      <img class="task-btn-icon" [src]="taskSelect!.icon">
      @if (compareScores) {
        <p class="font-18 task-btn-task-points" *ngIf="compareScores && taskSelect!.shouldDisplayPreviousScore()">{{ taskSelect!.displayPreviousScore() }}</p>
        <p class="font-18 task-btn-task-score" *ngIf="taskSelect!.shouldDisplayScore()">{{ taskSelect!.displayScore() }}</p>
      } @else {
        <div class="score-container">
          <div class="scorebox-wrapper" [ngClass]="[ wrapperGrids ]">
            @for (scoreBox of scoreBoxes; track scoreBox.id) {
              @if (scoreBox.icon) {
                <p class="font-18 task-btn-passage-scorebox" [ngStyle]="{'background-image':'url(' + scoreBox.background + ')'}">
                  <img src="{{ scoreBox.icon }}" />
                </p>
              } @else {
                <p class="font-18 task-btn-scorebox" [ngStyle]="{'background-image':'url(' + scoreBox.background + ')'}">
                  {{ scoreBox.started ? scoreBox.score + '%' : '' }}
                </p>
              }
            }
          </div>
        </div>
      }
    } @else {
      <p class="font-18 pre-task-btn-task-type" [hidden]="taskSelect!.showPassageTitle">{{taskSelect!.type}}</p>
      <p class="font-18 pre-task-btn-task-name" [hidden]="taskSelect!.showPassageTitle">{{taskSelect!.name}}</p>
      <p [hidden]="!taskSelect!.showPassageTitle" class="task-btn-passage-title font-passage-title">{{ taskSelect!.passageTitle | formatString }}</p>
      <img class="pre-task-btn-icon" [src]="taskSelect!.icon">
      <p class="font-18 pre-task-btn-task-score"
         [ngClass]="{'left-task-score': taskSelect!.pointsLeft, 'secondary-theme' : (taskSelect!.theme === themes.secondary) }"
         *ngIf="isPreDiagnosticStudent && taskSelect!.shouldDisplayScore()">{{ taskSelect!.displayScore() }}</p>
      <p class="font-18 diagnostic-task-btn-task-prev-score"
         [ngClass]="{'left-task-score': taskSelect!.pointsLeft, 'secondary-theme' : (taskSelect!.theme === themes.secondary) }"
         *ngIf="!isPreDiagnosticStudent && compareScores && taskSelect!.shouldDisplayPreviousScore()">{{ taskSelect!.displayPreviousScore() }}</p>
      <p class="font-18 diagnostic-task-btn-task-score"
         [ngClass]="{'left-task-score': taskSelect!.pointsLeft, 'secondary-theme' : (taskSelect!.theme === themes.secondary) }"
         *ngIf="!isPreDiagnosticStudent && taskSelect!.shouldDisplayScore()">{{ taskSelect!.displayScore() }}</p>
    }
  </button>
</ng-container>
